const i18n = {
  'setting': {
    'modifyPassword': '設定新密碼',
    'deleteAccount': '刪除帳號',
  }
};
export default i18n;
